export default __webpack_public_path__ + "static/media/men.2c358f67.jpg";